import React, { useState } from "react";
import { useAuth } from "../store/AuthContext";
import Button from "./Button";

const LoginForm: React.FC = () => {
  const { signInWithOtp, signInWithOAuth } = useAuth();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "sending" | "sent" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const submit = async () => {
    if (!email || status === "sending") return;
    setStatus("sending");
    const { error } = await signInWithOtp(email);
    if (error) {
      setStatus("error");
      setErrorMessage(error);
    } else {
      setStatus("sent");
    }
  };

  const submitOAuth = async () => {
    const { error } = await signInWithOAuth("google");
    if (error) {
      setStatus("error");
      setErrorMessage(error);
    }
    // On success the browser is redirected to Google, so no further local state change here.
  };

  if (status === "sent") {
    return (
      <div className="flex flex-col items-center mt-8 gap-2">
        <p className="text-lg">Check your email</p>
        <p className="text-sm text-gray-600">We sent a sign-in link to {email}.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center mt-8 gap-4">
      <p className="text-xl px-1 py-2 border-b border-solid border-black">Pattern Manager</p>
      <p className="text-sm">Sign in to see your patterns.</p>
      <div className="flex flex-col items-center px-14 py-4 gap-4 border border-black/50 rounded-lg shadow-md">
        <Button onClick={submitOAuth} disabled={status === "sending"}>
          <p className="text-sm">Sign in with Google</p>
        </Button>
        <p className="text-xs text-gray-500">or</p>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="border rounded-md px-2 py-1 text-sm w-64"
        />
        <Button onClick={submit} disabled={status === "sending"}>
          <p className="text-sm">{status === "sending" ? "Sending..." : "Send sign-in link"}</p>
        </Button>
      </div>
      {status === "error" && errorMessage && (
        <p className="text-red-600 text-sm">{errorMessage}</p>
      )}
    </div>
  );
};

export default LoginForm;
